import { render, staticRenderFns } from "./Editar-Cardapio.vue?vue&type=template&id=f2f63ef2&scoped=true&"
import script from "./Editar-Cardapio.vue?vue&type=script&lang=js&"
export * from "./Editar-Cardapio.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Cardapio.vue?vue&type=style&index=0&id=f2f63ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f63ef2",
  null
  
)

component.options.__file = "Editar-Cardapio.vue"
export default component.exports